export const environment = {
  production: false,
  /**
   * Local browser only (ng serve / ng build --configuration development).
   * Sends devLineUid to API — requires LineAuth:AllowDevUidBypass=true on API dev.
   * NEVER enable on deployed LIFF builds.
   */
  useMockLiff: false,
  /** LINE userId (sub) — required for mock auth */
  // mockLineUid: 'U06c988e2a0431aa149672747eac92b41',
  // mockDisplayName: 'Ball@Ya',
  mockLineUid: 'U1e51fe836f9f8c3d72670ef37340c5b8',
  mockDisplayName: 'Bou',
  mockPictureUrl:
    'https://i.pinimg.com/1200x/e5/b6/02/e5b602f54236b1cca870e3f88c326268.jpg',
  /** TH | EN — used for register / OTP language field */
  mockLanguage: 'TH' as const,
  apiPrivateUrl: 'https://api-dev-platfrom.cityparking.asia',
  // apiPrivateUrl: 'http://localhost:5195',
  urlInvite: 'https://liff.line.me/2010681877-yHsA5Reu', // UAT
  apiKey: '9ca2b9b7-776a-4477-ab4d-45751af08cff',
  publicLiffId: '2010681877-yHsA5Reu', // UAT
  webpayUrl: 'https://webpay-dev.cityparking.asia/payment/invoice?data=',
  webpayMemberUrl: 'https://webpay.cityparking.asia/member-invoice?data=',
  /** true = แสดง console.log ทั้งโปรเจกต์ / false = ปิดทั้งหมด */
  enableConsoleLog: true,
};
